// routes
import { PATH_AFFILIATE, PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: icon("af_dash"),
  invite: icon("af_business"),
  commission: icon("af_bill"),
  settlement: icon("af_bank"),
  leads: icon("af_leads"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "Dashboard",
        path: PATH_AFFILIATE.dashboard,
        icon: ICONS.dashboard,
      },
      {
        title: "Invite MSMEs",
        path: PATH_AFFILIATE.invitation,
        icon: ICONS.invite,
      },
      {
        title: "Commission",
        path: PATH_AFFILIATE.Commission,
        icon: ICONS.commission,
      },
      {
        title: "Leads",
        path: PATH_AFFILIATE.Leads,
        icon: ICONS.leads,
      },
      {
        title: "Settlement",
        path: PATH_AFFILIATE["bank-accounts"],
        icon: ICONS.settlement,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
